module.exports = __webpack_public_path__ + "img/20220524121508287rvv.6aff2aa6.jpg";